import { applyActionCode } from 'firebase/auth';
import React, { useEffect, useState } from 'react';
import { auth } from '../utils/firebase';
import { Link, useLocation } from 'react-router-dom';
import { Logo } from '../components/logo';
import { CircleCheck, CircleX } from 'lucide-react';
import { LANDING_PATH, LOGIN_PATH } from '../App';

const EmailVerification = () => {
    const location = useLocation();
    const [message, setMessage] = useState("");
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            setLoading(true);
            const queryParams = new URLSearchParams(location.search);
            const mode = queryParams.get("mode");
            const oobCode = queryParams.get("oobCode");
            if (mode !== "verifyEmail") {
                setIsError(true);
                setMessage("Something went wrong. Unusual action detected.");
                setLoading(false);
                return;
            }
            if (!oobCode) {
                setIsError(true);
                setMessage("Something went wrong. Code is missing.");
                setLoading(false);
                return;
            }
            try {
                await applyActionCode(auth, oobCode);
                setMessage("Email verified successfully.");
            } catch (error) {
                setIsError(true);
                setMessage("Something went wrong. Please try again later.");
                console.log(error);
            } finally {
                setLoading(false);
            }
        })();
    }, [location]);


    if (loading) {
        return (
            <main className='page-size flex-center'>
                <div className='loading loading-md loading-bars' />
            </main>
        );
    }

    return (
        <main className='page-size flex-center p-4'>
            <div className="flex-center p-8 gap-2 border w-full max-w-md">
                <div className="flex flex-row gap-4 h-12 items-center">
                    <Logo className={"h-full object-contain translate-y-1"} />
                    <h1 className='text-xl font-bold text-nowrap'>
                        Email Verification
                    </h1>
                </div>
                <div className='w-full divider m-0' />
                <p className='text-center leading-1 inline-flex items-center w-full mb-2'>
                    {
                        isError
                            ? <CircleX className='inline pr-1 text-error' />
                            : <CircleCheck className='inline pr-1 text-success' />
                    }
                    {message}
                </p>
                {
                    isError ? (
                        <Link to={LANDING_PATH} className="w-full btn btn-outline">
                            Back to Home
                        </Link>
                    ) : (
                        <Link to={LOGIN_PATH} className="w-full btn btn-primary font-bold">
                            Login Now
                        </Link>
                    )
                }
            </div>
        </main>
    );
}

export default EmailVerification;
